import React, { useEffect, useState, useRef, useContext } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import $ from 'jquery';
import { CheckSession, FormatCurrency, GetCoockie, GetShoppingCart, KImageURL, DefaultImage } from "../GlobalScript";
import Cookies from 'js-cookie';
import Select from 'react-select';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import InputGroup from 'react-bootstrap/InputGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import FooterDealer from '../FooterDealer';
import Modal from 'react-bootstrap/Modal';
import PulseLoader from "react-spinners/PulseLoader";

export default function Catalog() {

    const navigate = useNavigate();
    const location = useLocation();
    const [vehicle, setVehicle] = useState('');
    const [model, setModel] = useState('');
    const [year, setYear] = useState('');
    const [searchVehicle, setSearchVehicle] = useState('');
    const [searchModel, setSearchModel] = useState('');
    const [searchYear, setSearchYear] = useState('');
    const [category, setCategory] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState(new Set());
    const [catalogItems, setCatalogItems] = useState([]);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [ModelList, setModelList] = useState(null);
    const [YearList, setYearList] = useState(null);
    const [VehicleList, setVehicleList] = useState(null);
    const [pop, setPop] = useState(false);
    const [FirstLoad, setFirstLoad] = useState(false);
    const [ChangeVehicle, setChangeVehicle] = useState(false);

    useEffect(() => {
        document.title = 'K-Dealer - Catalog';
    });

    const handlePop = () => setPop(true);
    const handleClosePop = () => setPop(false);

    useEffect(() => {
        if (!location.state || !location.state.vehicle || location.state.vehicle.length === 0
            || !location.state.model || location.state.model.length === 0
            || !location.state.year || location.state.year.length === 0) {
            navigate('/dealerhome');
            return;
        }
        setVehicle(location.state.vehicle)
        setSearchVehicle(location.state.vehicle);
        setFirstLoad(true);
    }, [location])

    useEffect(() => {
        if (!VehicleList) {
            LoadVehicleList();
        }
    }, [VehicleList]);

    useEffect(() => {
        if (vehicle) {
            LoadYearList();
            if (FirstLoad) {
                setYear(location.state.year);
                setModel(location.state.model);
                setSearchYear(location.state.year);
                setSearchModel(location.state.model);
            }
        }
        if (!vehicle || FirstLoad === false)
        {
            setYear('');
            setModel('');
            setYearList(null);
            setModelList(null);
        }
    }, [vehicle]);

    useEffect(() => {
        if (year) {
            LoadModelList();
            if (FirstLoad) {
                setModel(location.state.model);
                getCategories();
                getCatalogItems();
            }
            setFirstLoad(false);
        }
        if (!year || FirstLoad === false) {
            setModel('');
            setModelList(null);
        }
    }, [year]);

    const LoadVehicleList = async () => {
        try {
            CheckSession();
            handlePop();
            const response = await fetch("catalog/GetVehicleList");
            if (response.status !== 200) {
                return;
            }
            const lst = await response.json();
            setVehicleList(lst);
        }
        catch (e) {
            console.log(e);
        }
        finally {
            handleClosePop();
        }
    }

    const LoadYearList = async () => {
        try {
            CheckSession();
            handlePop();
            const response = await fetch('catalog/GetYearList/' + vehicle);
            if (response.status !== 200) {
                return;
            }
            const lst = await response.json();
            setYearList(lst);
        }
        catch (e) {
            console.log(e);
        }
        finally {
            handleClosePop();
        }
    }

    const LoadModelList = async () => {
        try {
            if (!year || !vehicle ) {
                return;
            }
            handlePop();
            const data = [vehicle, year];
            CheckSession();
            const rqst = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch('catalog/GetModelList/', rqst);
            if (response.status !== 200) {
                return;
            }
            const lst = await response.json();
            setModelList(lst);
        }
        catch (e) {
            console.log(e);
        }
        finally {
            handleClosePop();
        }
    }

    const getCategories = async () => {
        try {
            if (!searchYear || !searchVehicle || !searchModel) {
                return;
            }
            handlePop();
            const data = [searchVehicle, searchYear, searchModel];
            CheckSession();
            const rqst = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch('catalog/GetCategoryList/', rqst);
            if (response.status !== 200) {
                return;
            }
            const lst = await response.json();
            setCategory(lst);
        }
        catch (e) {
            console.log(e);
        }
        finally {
            handleClosePop();
        }
    }

    const getCatalogItems = async () => {
        try {
            if (!searchYear || !searchVehicle || !searchModel) {
                return;
            }
            handlePop();
            const data = {
                vehicle: searchVehicle,
                year: searchYear,
                model: searchModel,
                category: selectedCategories && selectedCategories.size > 0 ? [...selectedCategories] : null
            }
            CheckSession();
            const rqst = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch('catalog/GetItemList/', rqst);
            if (response.status !== 200) {
                return;
            }
            const lst = await response.json();
            setCatalogItems(lst);
        }
        catch (e) {
            console.log(e);
        }
        finally {
            handleClosePop();
        }
    }

    useEffect(() => {
        getCatalogItems();
    }, [selectedCategories])
    
    //Leave modal code just in case we add one later to this page
    const handleDetailsModalShow = () => {
        setShowDetailsModal(true);
    }
    const handleDetailsModalClose = () => {
        setShowDetailsModal(false);
    }

    const handleChangeCategory = (e) => {
        const set = new Set(selectedCategories);
        if (e.target.checked) {
            set.add(e.target.value);
        }
        else if (set.has(e.target.value)) {
            set.delete(e.target.value);
        }
        setSelectedCategories(set);
        console.log(selectedCategories);
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === 'vehicle') {
            setVehicle(value);
        } else if (name === 'model') {
            setModel(value);
        } else if (name === 'year') {
            setYear(value);
        }
    }

    const changeVehicle = () => {
        setSearchModel(model);
        setSearchVehicle(vehicle);
        setSearchYear(year);
        setChangeVehicle(true);
       
    }

    useEffect(() => {
        if (ChangeVehicle === true && searchModel && searchVehicle && searchYear) {
            getCategories();
            getCatalogItems();
            setChangeVehicle(false);
        }
    }, [ChangeVehicle, searchModel, searchVehicle, searchYear]);

    const clearCategory = () => {
        setSelectedCategories(null);
        $('input:checkbox[id^="cat"]').prop('checked', false);
    }

    const goItemPage = (item) => {
        navigate('/catalog/item', { state: { vehicle: vehicle, model: model, year: year, item: item } })
    }

    return (
        <>
            <Container className="checkout-container main-container dealer-section min-height-spacing-lg">

                <Row className="mb-3">
                    <Col sm={12} className="">
                        <Card className="green-border-bottom">
                            <Card.Body>
                                <Row>
                                    <Col sm={4} className="border-right">
                                        <Row>
                                            <Col sm={8}>
                                                <h1 className="heading"><span className="green-text">2025</span> KLX230R</h1>
                                            </Col>
                                            <Col sm={4}>
                                                <img src="https://content2.kawasaki.com/ContentStorage/KMC/ProductTrimGroup/60/264cd617-a42e-480c-af87-33282b85b988.png?w=300&v=01" alt="vehicle" className="category-header-image" />
                                            </Col>
                                        </Row>
                                    </Col>

                                    <Col sm={8}>
                                        <Row>
                                            <Col sm={3}>
                                                <Form.Select aria-label="Vehicle" value={vehicle} onChange={handleChange} name="vehicle" className="mt-2">
                                                    <option value={''}>Select a vehicle</option>
                                                    {VehicleList && VehicleList.map(op => (
                                                        <option key={op.value} value={op.value}>{op.label}</option>
                                                    ))}
                                                </Form.Select>
                                            </Col>
                                            <Col sm={3}>
                                                <Form.Select aria-label="Year" value={year} onChange={handleChange} name="year" className="mt-2">
                                                    <option value={''}>Select a year</option>
                                                    {YearList && YearList.map(op => (
                                                        <option key={op.value} value={op.value}>{op.label}</option>
                                                    ))}
                                                </Form.Select>
                                            </Col>
                                            <Col sm={3}>
                                                <Form.Select aria-label="Model" value={model} onChange={handleChange} name="model" className="mt-2">
                                                    <option value={''}>Select a model</option>
                                                    {ModelList && ModelList.map(op => (
                                                        <option key={op.value} value={op.value}>{op.label}</option>
                                                    ))}
                                                </Form.Select>
                                            </Col>
                                           
                                            <Col sm={3}>
                                                <Button variant="secondary" onClick={changeVehicle} disabled={!vehicle || !year || !model}>
                                                    <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                    </svg>
                                                    CHANGE VEHICLE
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col sm={3}>
                        <div className="sticky-top">
                            <Card className="summary-card mb-5">
                                <Card.Body>
                                    <Row className="title-group summary-title keep-layout checkout-title-row">
                                        <Col className="checkout-title black-border-bottom">
                                            <Card.Title className="heading" role="heading">CATEGORY</Card.Title>
                                        </Col>
                                        <Col className="black-border-bottom">
                                            <Card.Subtitle className="smaller-text underline right-text red" onClick={clearCategory}>Clear All</Card.Subtitle>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col sm={12}>
                                            {category.map(cat => (
                                                <Form.Check id={"cat" + cat.value} key={"cat" + cat.value}
                                                    type="checkbox"
                                                    label={cat.label}
                                                    value={cat.value}
                                                    onChange={handleChangeCategory}
                                                    className="mt-2"
                                                />
                                            ))}
                                        </Col>
                                    </Row>
                                    
                                </Card.Body>
                            </Card>
                        </div>
                    </Col>

                    <Col sm={9}>
                        <Row>
                            {catalogItems.map((item, index) => (
                                <Col lg={4} md={6} key={item.id} className="catalog-item-col">
                                    <Card className="catalog-item-card" onClick={() => goItemPage(item)}>
                                        <Card.Body className="green-border-bottom-thin">
                                            <Row>
                                                <Col sm={12} className="text-center mb-4">
                                                    <img src={KImageURL(item.itemNumber, item.img)}
                                                        onError={({ currentTarget }) => {
                                                            currentTarget.onerror = null;
                                                            currentTarget.src = DefaultImage;
                                                        }}
                                                        alt={item.descr} className="catalog-item-image"
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-2">
                                                <Col sm={9}>
                                                    <h2 className="heading">{item.descr}</h2>
                                                </Col>

                                                <Col sm={3}></Col>
                                            </Row>

                                            <Row>
                                                <Col sm={8}>
                                                    <p className="smaller-text">#{item.itemNumber}</p>
                                                    <p className="smaller-text">Dealer Price:</p>
                                                    <p className="smaller-text">MSRP:</p>
                                                </Col>
                                                <Col sm={4}>
                                                    <br />
                                                    <h2 className="heading catalog-item-price">{item.price}</h2>
                                                    <p className="smaller-text">{item.retailPrice}</p>
                                                </Col>
                                            </Row>
                                        </Card.Body>

                                        <div className="catalog-item-button">
                                            <h1 className="heading">+ Add to Cart</h1>
                                        </div>
                                    </Card>
                                </Col>
                            )) }
                        </Row>
                    </Col>
                </Row>

            </Container>

            <Modal className="loader-div" id="loader" show={pop} onHide={handleClosePop} size="lg" centered backdrop="static" keyboard={false}>
                <PulseLoader color="#66cc33" size="20px" margin="12px" />
            </Modal>

            <FooterDealer />           
        </>
    );
}